import {api} from '@/http'

// 获取职位管理列表
const getPositionManageList = (data, callback, back) => {
  api('/api/position', 'get', data, callback, back)
}

export default {
  getPositionManageList
}



// WEBPACK FOOTER //
// ./src/api/positionManage/index.js